import React, { useEffect, useState, useRef } from "react";
import {
  CommonErrorMsg,
  ErrorMsg,
  InfoIcon,
  ValidateForm,
} from "../../Util/common";
import { ImageURL } from "../../Util/axios_core_helper";
import { generateGuid } from "../../Kendo/kendo_common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { toast } from "react-toastify";

export const VirtualImageMapping = ({
  facilityDetails,
  setFacilityDetails,
  goNext,
  goBack,
}) => {
  const [VirtualMappingForm, setVirtualMappingForm] = useState({
    VirtualMappingID: 0,
    VirutalMappingTitle: "",
    KuulaLink: "",
    Image: "",
    OldImagePath: "",
    previewUrl: "",
    FacilityID: 0,
  });
  useEffect(() => {}, [facilityDetails]);
  const clearForm = () => {
    setVirtualMappingForm({
      VirtualMappingID: 0,
      VirutalMappingTitle: "",
      KuulaLink: "",
      Image: "",
      OldImagePath: "",
      previewUrl: "",
      FacilityID: 0,
    });
    setError({});
    setEditVisible(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const [VirtualMappingFormList, setVirtualMappingFormList] = useState([]);

  const [editVisible, setEditVisible] = useState(false);

  const [error, setError] = useState({});

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setVirtualMappingForm((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        setVirtualMappingForm((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        let temp = VirtualMappingForm;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setVirtualMappingForm((prev) => ({
            ...prev,
            previewUrl: reader.result,
            OldImagePath: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setVirtualMappingForm(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setVirtualMappingForm((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  useEffect(() => {
    if (facilityDetails && facilityDetails.VirtualMapping) {
      const virtualMappingList = facilityDetails.VirtualMapping.map(
        (mapping) => ({
          ...mapping,
          previewUrl: mapping.previewUrl
            ? mapping.previewUrl
            : `${ImageURL}/${mapping.oldImagePath}`,
        })
      );
      setVirtualMappingFormList(virtualMappingList);
    }
  }, [facilityDetails]);

  // const onVirutalMappingformSubmit = (e) => {
  //
  //   e.preventDefault();

  //   const err = ValidateForm(e);
  //   if (err) {
  //     setError(err);
  //     return;
  //   }

  //   setError({ EmptyList: false });
  //   const finalImagePath =
  //     VirtualMappingForm.Image || VirtualMappingForm.OldImagePath;

  //   // Prepare a new or updated row
  //   const newRow = {
  //     ...VirtualMappingForm,
  //     guid: VirtualMappingForm.guid || generateGuid(),
  //     savedBy: 0,
  //     facilityID: 0, // Adjust based on actual values
  //     kuulaLink: VirtualMappingForm.KuulaLink,
  //     virutalMappingTitle: VirtualMappingForm.VirutalMappingTitle,
  //     virtualMappingID: VirtualMappingForm.VirtualMappingID || 0, // Default to 0 if not provided
  //     image: finalImagePath,
  //   };

  //   if (newRow.virtualMappingID > 0) {
  //     // Update existing row based on `virtualMappingID`
  //     const updatedList = VirtualMappingFormList.map((item) =>
  //       item.virtualMappingID === newRow.virtualMappingID ? newRow : item
  //     );
  //     setVirtualMappingFormList(updatedList);
  //   } else if (newRow.guid) {
  //     // Update or add based on GUID
  //     const existingRow = VirtualMappingFormList.find(
  //       (item) => item.guid === newRow.guid
  //     );
  //     if (existingRow) {
  //       const updatedList = VirtualMappingFormList.map((item) =>
  //         item.guid === newRow.guid ? newRow : item
  //       );
  //       setVirtualMappingFormList(updatedList);
  //     } else {
  //       setVirtualMappingFormList((prevList) => [...prevList, newRow]);
  //     }
  //   } else {
  //     // Add as a new entry if no `guid` or `virtualMappingID` exists
  //     setVirtualMappingFormList((prevList) => [...prevList, newRow]);
  //   }

  //   clearForm();
  // };
  const onVirutalMappingformSubmit = (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = VirtualMappingForm.Image?.size > maxSizeInBytes;

    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

    let urlInvalid = false;
    if (!urlPattern.test(VirtualMappingForm.KuulaLink.trim())) {
      urlInvalid = true;
    }

    const finalImagePath =
      VirtualMappingForm.Image || VirtualMappingForm.OldImagePath;

    e.target.Image.value = finalImagePath;

    const err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
        InvalidURL: urlInvalid,
      }));
    } else if (!oversize && !urlInvalid) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        InvalidURL: false,
      }));

      // setError({ EmptyList: false });

      const newRow = {
        ...VirtualMappingForm,
        guid: VirtualMappingForm.guid || generateGuid(),
        savedBy: 0,
        facilityID: 0,
        kuulaLink: VirtualMappingForm.KuulaLink,
        virutalMappingTitle: VirtualMappingForm.VirutalMappingTitle,
        virtualMappingID:
          VirtualMappingForm.VirtualMappingID > 0
            ? VirtualMappingForm.VirtualMappingID
            : VirtualMappingForm.guid || generateGuid(),
        image: finalImagePath,
      };

      if (newRow.virtualMappingID > 0) {
        const updatedList = VirtualMappingFormList.map((item) =>
          item.virtualMappingID === newRow.virtualMappingID ? newRow : item
        );
        setVirtualMappingFormList(updatedList);
      } else if (newRow.guid) {
        const existingRow = VirtualMappingFormList.find(
          (item) => item.guid === newRow.guid
        );
        if (existingRow) {
          const updatedList = VirtualMappingFormList.map((item) =>
            item.guid === newRow.guid ? newRow : item
          );
          setVirtualMappingFormList(updatedList);
        } else {
          setVirtualMappingFormList((prevList) => [...prevList, newRow]);
        }
      } else {
        setVirtualMappingFormList((prevList) => [...prevList, newRow]);
      }
      clearForm();
    } else {
      if (oversize) {
        setError((prevError) => ({
          ...prevError,
          InValidFileSize: true,
        }));
      }
      if (urlInvalid) {
        setError((prevError) => ({
          ...prevError,
          InvalidURL: true,
        }));
      }
    }
  };
  const [removedVirtualMappingIds, setRemovedVirtualMappingIds] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (VirtualMappingFormList.length === 0) {
      setError({ EmptyList: true });
      return;
    }
    setFacilityDetails((prev) => ({
      ...prev,
      VirtualMapping: VirtualMappingFormList,
      removedVirtualMappingIds,
    }));
    goNext();
  };

  const handleVirtualMappingAddDeleteClick = (e) => {
    // Find the index of the item to delete based on `virtualMappingID` or `guid`
    const index = VirtualMappingFormList.findIndex((item) =>
      e.virtualMappingID
        ? item.virtualMappingID === e.virtualMappingID
        : item.guid === e.guid
    );

    if (index !== -1) {
      const temp = [...VirtualMappingFormList];

      if (temp[index].virtualMappingID) {
        setRemovedVirtualMappingIds((prev) =>
          prev
            ? `${prev},${temp[index].virtualMappingID}`
            : `${temp[index].virtualMappingID}`
        );
      }

      // Remove the item from the list
      const updatedList = temp.filter((_, i) => i !== index);
      setVirtualMappingFormList(updatedList);
    }
  };

  const titleRef = useRef(null);

  const handleVirtualMappingEditClick = (e) => {
    // Find the row to edit based on `virtualMappingID` or `guid`
    const rowToEdit = VirtualMappingFormList.find((item) =>
      e.virtualMappingID > 0
        ? item.virtualMappingID === e.virtualMappingID
        : item.guid === e.guid
    );

    if (rowToEdit) {
      setVirtualMappingForm({
        ...rowToEdit,
        VirutalMappingTitle: rowToEdit.virutalMappingTitle || "",
        KuulaLink: rowToEdit.kuulaLink || "",
        OldImagePath: rowToEdit.oldImagePath || "",
        Image: rowToEdit.image || rowToEdit.oldImagePath, // Handle fallback logic for image
        previewUrl: rowToEdit.previewUrl || "",
        VirtualMappingID:
          rowToEdit.virtualMappingID > 0
            ? rowToEdit.virtualMappingID
            : rowToEdit.guid, // Fallback to `guid` if `virtualMappingID` is invalid
      });

      setEditVisible(true);
      titleRef.current.focus();
    }
  };

  const onValidationURL = (name, val) => {
    try {
      new URL(val.trim());
      setError((prevErr) => ({
        ...prevErr,
        [name]: false,
      }));
    } catch (error) {
      setError((prevErr) => ({
        ...prevErr,
        [name]: true,
      }));
    }
  };

  return (
    <div>
      <form onSubmit={onVirutalMappingformSubmit}>
        <div className="row">
          <div className="col-md-3 mb-3">
            <label className="form-label">
              Title <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={30}
              className="form-control field"
              name="VirutalMappingTitle"
              value={VirtualMappingForm.VirutalMappingTitle}
              placeholder="Title"
              data-required="true"
              onChange={(e) => {
                setVirtualMappingForm((prev) => ({
                  ...prev,
                  VirutalMappingTitle: e.target.value,
                }));
                onValidation("VirutalMappingTitle", e.target.value);
              }}
              ref={titleRef}
            />
            <CommonErrorMsg
              text="Title is required"
              IsError={error.VirutalMappingTitle}
            />
            <CommonErrorMsg
              text="Please add at least one Data"
              IsError={error.EmptyList}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">
              Kuula Link <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={100}
              className="form-control field"
              name="KuulaLink"
              value={VirtualMappingForm.KuulaLink}
              placeholder="Kuula Link"
              data-required="true"
              onChange={(e) => {
                const value = e.target.value;

                setVirtualMappingForm((prev) => ({
                  ...prev,
                  KuulaLink: value,
                }));

                onValidation("KuulaLink", value); // Check if the field is required
                onValidationURL("linkInValid", value); // Check for URL validity
              }}
            />
            <CommonErrorMsg
              text={
                error.KuulaLink
                  ? "Kuula Link is required"
                  : error.linkInValid
                  ? "Please enter a valid URL"
                  : ""
              }
              IsError={error.KuulaLink || error.linkInValid}
            />

            {/* <CommonErrorMsg
              text="KuulaLink is required"
              IsError={error.KuulaLink}
            /> */}
          </div>
          <div className="col-md-4 mb-3">
            <div className="input-block mb-3">
              <label className="form-label">
                Cover Image <span className="text-danger">*</span>
                <InfoIcon
                  content="Kindly upload an Image within 500KB size;
                Please upload the image in JPEG, JPG or PNG format."
                />
              </label>
              <input
                className="form-control"
                style={{ height: "30px" }}
                type="file"
                name="file"
                accept="image/*"
                onChange={handleFileChange}
              />

              {error.Image && <ErrorMsg text=" Image is required" />}
              {error.ValidFile && (
                <ErrorMsg text="please upload Image file only" />
              )}
              {error.InValidFileSize && (
                <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
              )}
            </div>
            <div className="col-12 mb-3">
              {VirtualMappingForm.OldImagePath &&
                VirtualMappingForm.VirtualMappingID > 0 && (
                  <div
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "13px",
                    }}
                  ></div>
                )}

              {VirtualMappingForm.previewUrl && (
                <div
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "13px",
                  }}
                >
                  <img
                    src={VirtualMappingForm.previewUrl}
                    alt={VirtualMappingForm.previewUrl}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setVirtualMappingForm({
                        ...VirtualMappingForm,
                        OldImagePath: VirtualMappingForm.previewUrl,
                      });
                    }}
                  />
                </div>
              )}

              <input
                type="hidden"
                name="Image"
                id="image-name"
                data-required="true"
                value={VirtualMappingForm.Image || ""}
              />
              <input
                type="hidden"
                name="OldimagePath"
                value={VirtualMappingForm.OldImagePath}
              />
            </div>
          </div>
          <div className="col-md-2 mt-3">
            <button
              type="submit"
              className="btn btn-primary mt-0"
              title="Add Virtual Image Mapping"
            >
              <i className="las la-plus-circle"></i>
            </button>
          </div>
        </div>
      </form>
      <form id="subgrid-form" onSubmit={onSubmit}>
        <div className="col-md-12 mb-3" style={{ textAlign: "right" }}>
          <button
            type="button"
            className="butn-dark2 grey-btn m-2"
            // style={{ marginLeft: "5px" }}
            onClick={goBack}
          >
            <span>Back</span>
          </button>
          <button type="submit" className="butn-dark2">
            <span>Next</span>
          </button>
        </div>
        {VirtualMappingFormList.length > 0 && (
          <KendoGrid
            name={"homeBannerSubGrid"}
            disableToolbar={true}
            paggable={true}
            data={VirtualMappingFormList}
            columns={[
              {
                field: "virtualMappingID",
                hidden: true,
              },
              {
                field: "guid",
                hidden: true,
              },
              {
                field: "primaryId",
                hidden: true,
              },

              {
                field: "facilityID",
                hidden: true,
              },
              {
                field: "virutalMappingTitle",
                title: "Title",
              },
              {
                field: "kuulaLink",
                title: "Kuula Link",
              },

              {
                field: "previewUrl",
                title: "Cover Image",
                template: (dataItem) =>
                  dataItem.previewUrl
                    ? `<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <img
                          src="${dataItem.previewUrl}"
                          alt="Uploaded Preview"
                          style="width: auto; height: 40px; object-fit: cover;"
                        />
                      </div>`
                    : `<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        No Image
                      </div>`,
              },
            ]}
            showOptions={true}
            showDelete={true}
            showEdit={true}
            onEditClick={(e) => handleVirtualMappingEditClick(e)}
            onDeleteClick={(e) => handleVirtualMappingAddDeleteClick(e)}
            refreshWhen={VirtualMappingFormList.length}
          />
        )}
      </form>
    </div>
  );
};
